/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */
var FeatureListHeader = function () { return null; };
export { FeatureListHeader };
